import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFaceNeutral16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFaceNeutral16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0m1 0A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-9.275-.7a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m5.425-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0m-6.102 3.603a.5.5 0 1 0 0 1h5.916a.5.5 0 1 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFaceNeutral16);
